import { render, staticRenderFns } from "./review-content.vue?vue&type=template&id=194cdea6"
import script from "./review-content.vue?vue&type=script&lang=js"
export * from "./review-content.vue?vue&type=script&lang=js"
import style0 from "./review-content.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports